import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardSpacesScreen() {
    const { SpacesScreen } = useModule(moderationDashModuleQuery);
    return <SpacesScreen />;
}
